import React from 'react';
import { FadeIn } from '../animations/FadeIn';
import SafeIcon from '../../common/SafeIcon';

const features = [
  {
    title: 'Dose reminders',
    description: 'Never miss your weekly shot, with a smart reminder on your chosen day and time.',
    icon: 'Bell'
  },
  {
    title: 'Weight tracking',
    description: 'A live trend chart that visualizes your progress clearly over weeks and months.',
    icon: 'TrendingUp'
  },
  {
    title: 'Side-effect log',
    description: 'Note symptoms on a calendar to spot patterns and discuss with your provider.',
    icon: 'Activity'
  },
  {
    title: 'Calorie & intake tracking',
    description: 'Quick daily logging to ensure you are meeting your nutritional goals.',
    icon: 'Coffee'
  },
  {
    title: 'Body map',
    description: 'Tag injection sites easily to rotate them properly and avoid discomfort.',
    icon: 'User'
  },
  {
    title: 'Multi-language',
    description: 'Available in several languages to support users globally.',
    icon: 'Globe'
  }
];

export const Features = () => {
  return (
    <section id="features" className="py-24 bg-paper">
      <div className="max-w-6xl mx-auto px-6">
        <FadeIn className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-4xl font-semibold tracking-tight mb-4 text-ink">Everything you need, nothing you don't.</h2>
          <p className="text-lg text-ink/70 font-light">Purpose-built tools to make managing your GLP-1 medication simple and stress-free.</p>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <FadeIn key={index} delay={index * 0.1}>
              <div className="bg-white p-8 rounded-[24px] shadow-soft h-full border border-gray-100 hover:border-mint/30 transition-colors">
                <div className="w-12 h-12 rounded-2xl bg-paper flex items-center justify-center mb-6">
                  <SafeIcon name={feature.icon} className="text-2xl text-ink" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-ink">{feature.title}</h3>
                <p className="text-ink/70 leading-relaxed font-light">{feature.description}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};